import type { Hydra } from '@lib/types/hydra';

export interface Collection<T> {
  data: T[];
  total: number;
}

export default function transformHydraResponse<T>(response: Hydra<T>): Collection<T> {
  return {
    data: response.member,
    total: response.totalItems,
  };
}
